import {Pagination, Table, Tag} from "antd";
import Image from "~/components/Image";
import {numberFormat} from "~/utils";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import RecurringVoucherAction from "./RecurringVoucherAction";
import {
	voucherTypeLabels,
	voucherTypeColors
} from "../../constants";

function RecurringVoucherTable({items = [], pagination, onPaginationChange, setItemEdit, openModal}) {

	const {tableHeight} = useContext(AppContext);

	const handleEditClick = (item) => {
		setItemEdit(item);
		openModal('addEdit');
	}

	const handleDeleteClick = (item) => {
		setItemEdit(item);
		openModal('delete');
	}

	const columns = [
		{ title: 'Mã', dataIndex: 'code', key: "code", width: '80px', render: (_, item) => (<div>DK{item?.id}</div>)},
		{ title: 'Tên mẫu', dataIndex: 'name', key: "name", render: (_, item) => (<b>{item?.name}</b>)},
		{ title: 'Loại phiếu', dataIndex: 'voucherType', key: "voucherType", width: '130px', render: (_, item) => (<Tag color={voucherTypeColors[item?.voucherType]}>{voucherTypeLabels[item?.voucherType] || item?.voucherType}</Tag>)},
		{ title: 'Ngày chạy', dataIndex: 'dayOfMonth', key: "dayOfMonth", width: '110px', render: (_, item) => (<div>Ngày {item?.dayOfMonth}</div>)},
		{ title: 'Đối tượng', dataIndex: 'user', key: "user", width: '200px', render: (_, item) => {
			if(item?.user?.id) {
				return (
					<div className="d-flex gap align-items">
						<div className="avatar"><Image src={item.user?.avatar}/></div>
						<div>
							<b>{item.user?.firstname + ' ' + item.user?.lastname}</b>
							<p>{item.user?.username}</p>
						</div>
					</div>
				);
			}
			if(item?.voucherType === 'salary' && item?.payload?.object === 'company') {
				return <Tag color="blue">Công ty</Tag>;
			}
			return '--';
		}},
		{ title: 'Số tiền', dataIndex: 'price', key: "price", width: '150px', render: (_, item) => (<p><b>{numberFormat(item?.payload?.price)}đ</b></p>)},
		{ title: 'Trạng thái', dataIndex: 'active', key: "active", width: '120px', render: (_, item) => (
			item?.active ? <Tag color="green">Đang chạy</Tag> : <Tag color="default">Tạm dừng</Tag>
		)},
		{ title: 'Chạy gần nhất', dataIndex: 'lastRunMonth', key: "lastRunMonth", width: '130px', render: (_, item) => (item?.lastRunMonth || '--')},
		{ title: '#', dataIndex: 'action', key: "action", width: '130px', render: (_, item) => (
			<RecurringVoucherAction
				key={item.id}
				item={item}
				onClickEdit={handleEditClick}
				onClickDelete={handleDeleteClick}
			/>
		)},
	];

	const dataSource = items.map(row => ({
		key: row.id,
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default RecurringVoucherTable;
